import ApiBase from './ApiBase';
import axios from 'axios';
import { stringify } from '../components/forked/stringify';

/**
 * Investor Organization API
 */
class OrganizationApi extends ApiBase {
  /**
   * Check if organization ID already exists
   * @param {*} organizationId
   */
  async checkIdExists(organizationId) {
    const request = {
      url: `${this.API_URL}/organization?id=${organizationId}`,
      headers: this.getHeaders(),
      method: 'HEAD',
      validateStatus: function(status) {
        return status === 200 || status === 403 || status === 404;
      }
    };

    const response = await axios.request(request);

    if (response.status === 200 || response.status === 403) {
      return true;
    } else if (response.status === 404) {
      return false;
    }
  }

  /**
   * Get related contacts in excel .investorName
   * @param organizationId
   * @param {*} filters
   */
  async getRelatedContactsAsExcel(organizationId, filters) {
    const queryParameters = stringify(
      {
        organizationId: organizationId,
        investorName: filters.name
      },
      {
        arrayFormat: 'comma'
      }
    );
    const request = {
      url: `${this.API_URL}/organization/relatedinvestors/excel?${queryParameters}`,
      headers: this.getHeaders(),
      method: 'GET',
      responseType: 'blob'
    };

    const response = await axios.request(request);

    return response.data;
  }

  async downloadOrganizationImportTemplate() {
    const request = {
      url: `${this.API_URL}/organization/import/template`,
      method: 'GET',
      headers: this.getHeaders(),
      responseType: 'blob'
    };

    const response = await axios.request(request);
    return response.data;
  }

  async validateImportFromExcel(payload) {
    const request = {
      url: `${this.API_URL}/organizations/validateimport`,
      method: 'POST',
      headers: this.getHeaders(),
      data: payload
    };

    const response = await axios.request(request);
    return response.data;
  }

  async importOrganizationsFromExcel(payload) {
    const request = {
      url: `${this.API_URL}/organizations/importexcel`,
      method: 'POST',
      headers: this.getHeaders(),
      data: payload
    };

    const response = await axios.request(request);
    return response.data;
  }

  async exportOrganizationsExcel(filters, selectedIds, orphanVisibility) {
    let payload;
    if (selectedIds && selectedIds.length > 0) {
      payload = {
        id: `[${selectedIds.join(',')}]`,
        orphanVisibility: orphanVisibility
      };
    } else {
      payload = {
        name: filters.name,
        id: filters.id,
        status: filters.status,
        aka: filters.aka,
        fundFamilyId: filters.fundFamilyId,
        orphanVisibility: orphanVisibility
      };
    }

    const request = {
      url: `${this.API_URL}/organizations/export/excel`,
      method: 'POST',
      headers: this.getHeaders(),
      responseType: 'blob',
      data: payload
    };

    const response = await axios.request(request);
    return response.data;
  }
}

export default new OrganizationApi();
